// 渠道账户一体化，判断主渠道后台没登录时的重定向地址
export const filterLoginPath = () => {
  const env = process.env.VUE_APP_ENV_TYPE
  const pathMap = {
    loc: 'https://www-dev.local.wfq2020.com/channel-background/#/Login',
    dev: 'https://www-dev.local.wfq2020.com/channel-background/#/Login',
    test: 'https://www-test.wfq2020.com/channel-background/#/Login',
    prod: 'https://www.wfq2020.com/channel-background/#/Login',
  }
  return pathMap[env]
}
